export const debounce = (fn, wait, context = this) => {
  let timeout = null
  let callbackArgs = null

  const debounced = () => fn.apply(context, callbackArgs)

  return (...args) => {
    callbackArgs = args
    clearTimeout(timeout)
    timeout = setTimeout(debounced, wait)
  }
}
